// src/components/projects/TalentBasedCurriculum.js
import React from "react";
import "../../styles/tbc.css";
import { IconSchool } from "@tabler/icons-react";
import { IconBuilding } from "@tabler/icons-react";
import { IconHeart } from "@tabler/icons-react";
import { IconBallFootball } from "@tabler/icons-react";
import { IconUser } from "@tabler/icons-react";
import { IconSearch } from "@tabler/icons-react";
import { IconBook } from "@tabler/icons-react";

const curriculumData = [
  { title: "Children Development", description: "Focusing on early childhood education and skill-building.", icon: IconSchool },
  { title: "Partnership with Government", description: "Collaborating with policymakers for educational reforms.", icon: IconBuilding },
  { title: "Counseling & Rehabilitation", description: "Providing emotional and psychological support for students.", icon: IconHeart },
  { title: "Sports & Recreation", description: "Encouraging physical activity and teamwork through structured programs.", icon: IconBallFootball },
  { title: "Student Profiling", description: "Tracking student progress and tailoring learning experiences.", icon: IconUser },
  { title: "Research & Assessments", description: "Using data-driven insights to improve educational outcomes.", icon: IconSearch },
  { title: "Teaching & Learning", description: "Enhancing curriculum delivery through innovative teaching methods.", icon: IconBook }
];

const TalentBasedCurriculum = () => {
  return (
    <div className="talent-based-curriculum">
      <h1>Talent-Based Curriculum</h1>
      <p>Investing in South Africa’s future through structured development metrics.</p>

      <section className="curriculum-grid">
        {curriculumData.map((item, index) => (
          <div key={index} className="curriculum-card">
            {item.icon === IconSchool && <IconSchool size={40} />}
            {item.icon === IconBuilding && <IconBuilding size={40} />}
            {item.icon === IconHeart && <IconHeart size={40} />}
            {item.icon === IconBallFootball && <IconBallFootball size={40} />}
            {item.icon === IconUser && <IconUser size={40} />}
            {item.icon === IconSearch && <IconSearch size={40} />}
            {item.icon === IconBook && <IconBook size={40} />}
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </section>
    </div>
  );
};

export default TalentBasedCurriculum;